import { Avatar, AvatarProps, Menu } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

export const StyledAvatar = styled((props: AvatarProps) => <Avatar {...props} />)`
  &&& {
    width: 1em;
    height: 1em;
    font-size: inherit;
    vertical-align: unset;
  }
  &&&.ant-avatar > img {
    width: unset;
    height: unset;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
  &&&.ant-avatar-square {
    border-radius: 0px;
  }

  .anticon {
    vertical-align: top !important;
    height: 23px;
    line-height: 0 !important;
  }
  .ant-avatar-string {
    height: 23px;
    line-height: 23px;
  }
`;

export const StyledMenu = styled(Menu)`
  &&& {
    background-color: #0f273e;
    text-transform: uppercase;
    width: inherit;

    &&& .ant-menu-item:focus,
    .ant-menu-item:focus-within {
      background-color: #0a2136;
      outline: none;
    }
    &&& .ant-menu-item-selected {
      background-color: #0f273e;
      color: #4ba0f0;
    }
    .ant-menu-item-selected .anticon + span {
      color: #4ba0f0;
    }
    .ant-menu-item-selected .anticon {
      color: #4ba0f0;
    }
    .ant-menu-submenu-arrow {
      visibility: hidden;
    }
    .ant-menu-submenu-title,
    .ant-menu-item {
      &:hover {
        background-color: #0a2136;
      }
      color: #fff;
      font-size: 18px;
      padding: 0 18.5px !important;
      height: 60px;
      line-height: 60px;
      margin-top: 0px;
      margin-bottom: 0px;

      .ant-badge {
        line-height: 40px;
      }

      .anticon {
        font-size: 23px;
        margin-right: 20px;
      }
    }
  }
`;
